import { color } from './colors';

export const theme = {
  components: {
    Table: {
      borderColor: color.gray300,
      cellFontSize: 14,
      headerBg: color.gray50,
      headerColor: color.gray600,
      fontWeightStrong: 400
    },
    Pagination: {
      itemActiveBg: color.black2
    }
  }
};
